export const privacyPolicyDataSelector = (state) => state.privacyPolicy.data;
export const useCustomPrivacyPolicySelector = (state) => state.privacyPolicy.useCustomPrivacyPolicy;
